<app-header></app-header>
<div class="app__wrapper">
  <app-menu></app-menu>
  <div class="app__content">
    <router-outlet></router-outlet>
  </div>
</div>
<lib-alert></lib-alert>
